export enum Permissions {
  managementBasic = 'management:basic',
  managementWriteLimited = 'management:write:limited',
  managementWrite = 'management:write',
  managementPaymentMethodWrite = 'management:paymentmethod:write',
  orderFreeProduct = 'order:freeproduct',
  orderPaymentMethodInvoice = 'order:paymentmethod:invoice',
  creditMemoAdd = 'creditmemo:add',
  orderItemClose = 'orderitem:close',
  viewAllStorefronts = 'storefronts:all',
  storefrontOnboarding = 'storefront:onboarding',
  subscriptionPartnerAccessFeeRemove = 'subscription:partneraccessfee:remove'
}
